
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './MFAForm.scss';

import Button from 'src/component/UI/Button';
import VerificationInput from "react-verification-input";
import { useTranslation } from 'src/i18n';

export default function CodeAuth (props) {
  const {
    submitCode,
  } = props;
  const { t } = useTranslation();
  const [code, setCode] = useState(null);
  return (
    <>
      <p>{t('auth.code.enterCode')}</p>
      <div className='codeArea'>
        <VerificationInput autoFocus={true} validChars="0-9" placeholder=" " onChange={(e) => setCode(e)} classNames={{ container: "character" }} inputProps={{ inputMode: "numeric", autoComplete: "one-time-code" }} onComplete={(e) => { submitCode(e); }} />
      </div>
      <div className='otpButton'>
        <Button cta type='submit' onClick={() => submitCode(code)}>{t('auth.code.submit')}</Button>
      </div>
    </>
  );
}

CodeAuth.propTypes = {
  submitCode: PropTypes.func.isRequired,
};

CodeAuth.defaultProps = {
};
